import React from 'react';
import { useDispatch } from 'react-redux';
import { Chip, Grid, Typography } from '@mui/material';

import { FilesUtils, Icon, Utils } from 'app/main/components';
import FilesExplorerFileDialog from 'app/main/components/files-explorer/components/FilesExplorerFileDialog';
import { type MiddlewhereFile } from 'app/main/components/files-explorer/FilesUtils';

interface TotemFilesAttachmentsListProps {
	comsUid: string;
	filesList: MiddlewhereFile[];
}

export default function TotemFilesAttachmentsList(props: TotemFilesAttachmentsListProps) {
	const dispatch = useDispatch();

	const [openSelectedFileDialog, setOpenSelectedFileDialog] = React.useState(false);
	const [selectedFile, setSelectedFile] = React.useState<MiddlewhereFile>();
	const [fileContent, setFileContent] = React.useState<string>();
	const [isLoadingFile, setIsLoadingFile] = React.useState(false);

	const handleOpen = file => {
		if (!file.isDirectory) {
			setIsLoadingFile(true);
			setOpenSelectedFileDialog(true);
			setSelectedFile(file);
			Utils.executeApi.get({
				url: `/api/hrm/communications/${props.comsUid}/attachments/${file.name}`,
				dispatch,
				successHandler: ({ data }) => {
					setFileContent(data.content);
					setIsLoadingFile(false);
				}
			});
		}
	};

	return (
		<>
			{/* FILES CHIPS */}
			<Grid container spacing={1}>
				{props.filesList.length > 0 &&
					props.filesList.map((file, index) => (
						<Grid key={index}>
							<Chip
								icon={<Icon icon={FilesUtils.getFileIcon(file)} />}
								label={<Typography>{file.name}</Typography>}
								onClick={() => handleOpen(file)}
							/>
						</Grid>
					))}
			</Grid>
			{selectedFile && fileContent ? (
				<FilesExplorerFileDialog
					open={openSelectedFileDialog}
					onClose={() => setOpenSelectedFileDialog(false)}
					// FIXME: basePath is wrong but required
					basePath={`\\${selectedFile.name}`}
					selectedFile={selectedFile}
					selectedFileContent={fileContent}
					isLoadingFile={isLoadingFile}
					disableDelete
				/>
			) : (
				<></>
			)}
		</>
	);
}
